import { gql } from "@apollo/client";

import { ReportUpdatesQuery } from "../../../../../../__generated__/graphql";

export const updateProps = gql`
  fragment updateProps on Update {
    activityType
    activityDate
    author {
      id
      name
    }
    createdAt
    data {
      summary
      url
      redacted
      duration
      userName
      teamName
      childId
      formName
      update {
        id
        activityType
        authorName
        createdAt
      }
      answer {
        questionName
        question {
          id
        }
      }
      outcomeNames
      riskAssessment {
        id
      }
      repeatedName {
        id
        ignored
        partlyIgnored
        name {
          id
          name
          ignored
        }
      }
      questionId
      reclassifiedAnswers {
        optionId
        optionText
        answerId
        newStatus
      }
      linkedReport {
        id
        key
      }
    }
  }
`;

export const UPDATE_QUERY = gql`
  query reportUpdates($reportId: ID!, $filter: [String!], $page: Int!) {
    report(id: $reportId) {
      id
      updates(types: $filter, page: $page) {
        totalPages
        updates {
          id
          ...updateProps
        }
      }
    }
  }
  ${updateProps}
`;

export type Update = ReportUpdatesQuery["report"]["updates"]["updates"][number];
